<template>

    <div>

        <div class="h-16 sm:pr-12 flex items-center">

                          <svg class="w-8 h-8 animate-pulse text-red-700 mr-3 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path></svg>

                <input type="search"
                       name="query"
                       placeholder="Поиск раздела. Примеры: Экскаватор, минипогрузчик, говновоз"
                       required="required"
                       autocomplete="off" spellcheck="false" autocorrect="off"
                       class="p-4 text-gray-700 w-full bg-white border border-gray-300 rounded-lg focus:outline-none
                                focus:border-gray-400 focus:ring-0"
                        v-model="search_text" v-on:keyup="onSearch" />


        </div>


            <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                >

            <div class="w-full mb-3 rounded" v-if="results.result">

                <h4>Результат поиска для: <b>{{ search_text }}</b></h4>
                <ul class="border rounded border-gray-300">
                    <li v-for="result in results.result" :key="result.id"
                        class="cursor-pointer border-t hover:bg-gray-300">

                        <a :href="'/admin/garage/machinery-items/'+result.id +'/create'" class="" style="text-decoration: none">

                            <p class="text-xl text-indigo-700 pl-2">{{ result.name }}</p>
                            <p class="text-gray-600 text-sm pl-2">{{ result.bref_note_rent }}</p>
                        </a>

                    </li>

                </ul>

            </div>


        </transition>

    </div>

</template>

<script>
import {searchUrl} from 'conf@/common'
import debounce from 'lodash/debounce';

export default {
    name: "LiveSearch",
    data: function () {
        return {
            'search_text': '',
            'results': [],
        }
    },
    methods: {
        onSearch() {

            if (this.search_text.length>3) {

                // axios.get(searchUrl + this.search_text).then(responce => {
                //     this.results = responce.data
                // });
                this.search(this.search_text, this);

                return;
            }

            this.results = [];

        },

        search: debounce((needle, vm) =>{

             axios.get(searchUrl + vm.search_text).then(response => {
                    vm.results = response.data
                });

        },750)

    }
}
</script>

<style scoped>

</style>
